<template functional>
  <table>
    <tr>
      <th v-for="title in props.titles" :key="title" :item="title">{{ title }}</th>
    </tr>
    <tr
      v-for="(row, rowIndex) in props.content"
      :class="{ highlighted: row.highlighted }"
      :key="rowIndex"
      v-show="$options.showRow(row, props.filters, props.titles)"
    >
      <td v-for="(title, index) in props.titles" :key="index">
        {{ row[title] }}
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  props: {
    content: { type: Array, default: () => [] },
    titles: { type: Array, default: () => [] },
    filters: { type: Array, default: () => [] },
    tableComponents: { type: Object, default: () => {} },
  },
  showRow(row, filters = [], titles) {
    return filters.length ? filters.includes(row[titles[0]]) : true;
  },
};
</script>
